module.exports = __webpack_public_path__ + "img/test-bg-sm.3e6e877c.jpg";